<template>
<div class="hs-container">
    <div class="handle-box">
        <div class="handle-left">
            <div class="search-left">
                <el-select v-model="query.company_id" placeholder="婚庆执行公司" filterable clearable class="handle-input mr10">
                    <el-option v-for="(item, index) in dictionary.getPicker('company')" :key="index" :label="item.title" :value="item.id+''"></el-option>
                </el-select>
                <!-- <el-select v-model="query.supplier_id" placeholder="请选择供应商" class="handle-input mr10" filterable clearable>
                    <el-option v-for="(item, index) in supplierList" :key="index" :label="item.title" :value="item.id+''"></el-option>
                </el-select> -->
                <el-select v-model="query.hotel_id" placeholder="举办酒店" class="handle-input mr10" filterable clearable>
                    <el-option v-for="(item, index) in dictionary.getPicker('hotel')" :key="index" :label="item.title" :value="item.id+''"></el-option>
                </el-select>
                <el-date-picker class="daterange mr10" v-model="query.date_range" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                <el-button type="primary" class="btn-search ml8" @click="getTableData">搜索</el-button>
                <el-popover placement="bottom" width="600" trigger="click">
                    <div class="help-container">
                        <div>
                            <el-tag type="danger">花艺单状态</el-tag>
                            <dl class="help-box">
                                <dt>待分配:</dt>
                                <dd>策划师未提交需求</dd>
                            </dl>
                        </div>
                        <div>
                            <el-tag type="danger">已派单状态</el-tag>
                            <dl class="help-box">
                                <dt class="w150">已派单-[待审核]:</dt>
                                <dd>已派单-[待审核]</dd>
                            </dl>
                            <dl class="help-box">
                                <dt class="w150">已派单-[审核驳回]:</dt>
                                <dd>已派单-[审核驳回]</dd>
                            </dl>
                            <dl class="help-box">
                                <dt class="w150">已派单-[审核通过]:</dt>
                                <dd>已派单-[审核通过]</dd>
                            </dl>
                        </div>
                    </div>
                    <el-button slot="reference" class="ml8" type="danger">注解</el-button>
                </el-popover>
            </div>
        </div>
    </div>
    <!-- 搜索E -->
    <div class="table-box">
        <el-table @selection-change="handleSelectionChange" ref="table" :data="detailsData" border :height="tableHeight" :max-height="tableHeight" v-loading="loading">
            <el-table-column type="selection" :selectable="selectable"></el-table-column>
            <el-table-column prop="item_check_status" label="操作" align="left" width="300">
                <template slot-scope="scope">
                    <el-button type="primary" plain @click="flowerFile(scope.row)">导出</el-button>
                    <el-button type="primary" plain @click.stop="showDrawerPass(_self, 'summaryDetail', 'editDrawer', [scope.row,'edit'])">编辑</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="type" label="工作状态" align="center">
                            <template slot-scope="scope">
                                    <el-link v-if="scope.row.status == 0" type="info" size="mini">待分配</el-link>
                                    <el-link v-if="scope.row.status == 1" type="success" size="mini">部分分配</el-link>
                                    <el-link v-if="scope.row.status == 2" type="warning" size="mini">已完成</el-link>
                            </template>
            </el-table-column>
            <el-table-column prop="item_check_status" label="审核状态" align="center">
                <template slot-scope="scope">
                    <el-link type="primary" plain>{{getItemCheckTitle(scope.row.item_check_status)}}</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="company.title" label="执行公司" align="center" width="300">
            </el-table-column>
            <el-table-column prop="totals" label="婚期" align="center" width="300">
                <template slot-scope="scope">
                    <span>{{scope.row.event_start}}到{{scope.row.event_end}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="user.realname" label="创建人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip></el-table-column>

        </el-table>
    </div>
    <!-- 底部操作栏 -->
    <div class="footer-box">
        <!-- <el-select v-model="query.supplier_id" placeholder="请选择供应商" class="handle-input mr10" filterable clearable>
            <el-option v-for="(item, index) in supplierList" :key="index" :label="item.title" :value="item.id+''"></el-option>
        </el-select>
        <div class="download" v-if="query.is_flower_send==0">
            <el-button type="primary" class="btn-search ml8" @click="summaryDispatch">付款流程</el-button>
        </div> -->
        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[15, 20, 50, 100]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
        </div>
    </div>

    <plan-detail ref="planDetail" :parent="_self"></plan-detail>
    <summary-detail ref="summaryDetail" :parent="_self"></summary-detail>
    <process-view ref="processView" :parent="_self"></process-view>
</div>
</template>

<script>
import {
    showDrawerPass,
    getItemCheckTitle,
    objectSum,
    include
} from '@/utils/common.js';
import dictionary from '@/utils/dictionary';
import planDetail from './detail.vue';
import summaryDetail from './summaryDetail/detail.vue';
import processView from './process/process.vue';
const query = {
    company_id: "",
    date_range: [],
    is_flower_send: "0",
    supplier_id: "",
    hotel_id: "",
    ids: []
};

export default {
    components: {
        planDetail,
        summaryDetail,
        processView
    },
    data() {
        let tableHeight = window.innerHeight - 262;
        let windowheight = window.innerHeight;
        return {
            plannerList: [],
            tableData: [],
            query: Object.assign({}, query), // 搜索条件
            tableHeight: tableHeight,
            windowheight: windowheight,
            drawerVisible: false,
            pagination: {
                page: 1,
                limit: 15,
                totals: 0
            },
            loading: false,
            sort: {},
            router: '',
            detailsData: [],
            // 汇总分派
            bomRow: {
                list: [],
            },
            totals: {
                product_total: "",
                total: ""
            },
            supplierList: [],
            querys: {}

        };
    },
    watch: {
        $route: function (to, from) {}
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
        this.getItemCheckTitle = getItemCheckTitle;
        this.dictionary = dictionary;
        this.objectSum = objectSum;
        this.include = include

    },
    created() {
        let _this = this;
        _this.getTableData();
        _this.getSupplier();

        if (_this.$route.query.option) {
            _this.query = Object.assign(_this.query, JSON.parse(_this.$route.query.option)) // 搜索条件JSON.parse(_this.$route.query.option);
        }
    },
    methods: {
        getSupplier() {
            let _this = this;
            let url = '/api/supplier.company/role';
            let params = {
                role: "flower"
            };
            _this.$post(url, params).then((res) => {
                _this.supplierList = res.data.list;
            });
        },
        changeHandler(value) {
            this.query.is_flower_send = value;
            this.pagination.page = 1;
            this.getTableData();
        },
        flowerFile(row) {
            let _this = this;
            let url = '/api/wedding.flower/download';
            let options = {};
            options.id = row.id,
                this.$post(url, options).then(res => {
                    if (res.code == '200') {
                        let link = document.createElement('a');
                        link.href = res.data.url;
                        link.click();

                    }
                })

        },
        getTableData() {
            let _this = this;
            _this.loading = true;
            _this.router = _this.$route.path;
            let url = '/api/wedding.flower/summary';
            let query = this.query;
            query['pagination'] = _this.pagination;
            query['sort'] = _this.sort;
            this.$post(url, query).then((res) => {
                _this.loading = false;
                if (res.code == '200') {
                    _this.detailsData = res.data.list;
                    _this.pagination = res.data.pagination;
                    this.$nextTick(() => {
                        let ids = this.query.ids;
                        this.detailsData.forEach(item => {
                            if (include(item.id, ids)) {
                                _this.$refs.table.toggleRowSelection(item, true)
                            }

                        })
                    })

                } else {
                    this.$message(res.msg);
                }
            });
        },
        // 主表选中事件
        handleSelectionChange(e) {
            let ids = [];
            e.forEach((row, key) => {
                ids.push(row.id);
            });
            this.query.ids = ids;
        },
        selectable(row) {
            if (row.status == 2) {
                return true
            } else {
                return false
            }

        },
        summaryDispatch() {
            let _this = this;
            if (_this.query.ids.length == 0) {
                this.$message.error('请添加订单');
                return false
            }
            if (_this.query.supplier_id == "") {
                this.$message.error('请选择供应商');
                return false
            }
            if (_this.query.company_id == "") {
                this.$message.error('请选择婚庆承办公司');
                return false
            }
            if (_this.query.date_range == "") {
                this.$message.error('请选择婚期');
                return false
            }
            if (_this.$refs['processView']) {
                _this.$refs['processView'].showDrawer(_this.query)
            } else {
                _this.$nextTick(function () {
                    _this.$refs['processView'].showDrawer(_this.query);
                })
            }
        },
        // 排序
        sortChange(e) {
            if (e.order) {
                let sort = {};
                sort.field = e.prop;
                sort.order = e.order == 'descending' ? 'desc' : 'asc';
                this.sort = sort;
            } else {
                this.sort = {};
            }
            this.getTableData();
        },
        // 分页
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
        getStatus(status) {
            let title = '';
            switch (status) {
                case 0:
                    title = '待分配';
                    break;
                case 1:
                    title = '已派单';
                    break;
                case 2:
                    title = '分派中';
                    break;
                case 3:
                    title = '已完成';
                    break;
                case 4:
                    title = '已作废';
                    break;
                default:
                    title = '';
            }

            return title;
        },
        getPlannerList() {
            let _this = this;
            let url = '/api/ucenter.user/roleUserList';
            let params = {
                role_id: [32, 35]
            };
            _this.$post(url, params).then((res) => {
                _this.plannerList = res.data.list;
            });
        }
    }
};
</script>

<style lang="less">
@import url('@/assets/css/common.less');
</style>
